import { render, staticRenderFns } from "./informeCompra.vue?vue&type=template&id=597d5906&scoped=true&"
import script from "./informeCompra.vue?vue&type=script&lang=js&"
export * from "./informeCompra.vue?vue&type=script&lang=js&"
import style0 from "./informeCompra.vue?vue&type=style&index=0&id=597d5906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d5906",
  null
  
)

export default component.exports